'use strict';

var style = require('./style');

module.exports = style({
  prop: 'maxWidth',
  cssProperty: 'maxWidth',
  key: 'maxWidths',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/max-width.js
// module id = 384
// module chunks = 168707334958949